/* @flow */

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";
import { useUi } from "helpers/ui";
import cn from "classnames";
import styles from "./styles.scss";

import Button from "components/Button";

type Props = {
  className?: string,
  onClick: string => void,
};

const Hamburger = ({ className, onClick }: Props): React$Node => {
  const t = useTranslate();
  const { hamburgerOpen } = useUi();

  return (
    <Button
      aria-expanded={hamburgerOpen ?? "true"}
      aria-controls="mobileMenu"
      className={cn(
        className,
        styles.block
      )}
      onClick={onClick}
    >

      <div className={styles.contain}>
        <span className={styles.icon} />

        <span className={styles.text}>
          <span className="sr-only">{hamburgerOpen ? (t("HEADER.CLOSE")) : t("HEADER.OPEN")}</span>
          {t("HAMBURGER.TITLE")}
        </span>
      </div>
    </Button>
  );
};

export default Hamburger;
